module.exports = require('./helpers/bundle-url').getBundleURL('6qsPi') + "dark-mode.5b7c09da.svg";